<template>
  <div class="payment">
    <div class="head-title">
      <div class="img-box"><img src="../assets/logo.png" alt=""></div>
      <div class="title">收银台</div>
    </div>
    <div class="order-info">
      <div class="lable">订单信息</div>
      <div class="info">
        <p><span>订单号：{{orderNo}}</span></p>
        <p><span>应付金额：{{money}}元</span></p>
      </div>
      <!-- <div class="order-main">
        <p>订单详情</p>
        <div class="main">
          <p><span>商品名称：</span></p>
          <p><span>交易金额：</span></p>
          <p><span>商品名称：</span></p>

        </div>
      </div> -->
    </div>
    <div class="order-info">
      <div class="lable">选择支付方式</div>
      <div class="info">
        <el-radio-group v-model="radio" @change="handleRadioFun">
          <el-radio :label="1">微信支付</el-radio>
          <el-radio :label="2">支付宝支付</el-radio>
          <el-radio :label="3">奖金支付(当前奖金：￥{{balance}})</el-radio>
        </el-radio-group>
        <div class="password-box" v-if="radio == 3">
          <div class="inputTable">
            <input type="tel" v-model="password" maxlength="6">
            <div class="passIcon">
              <p><i v-show="password.length > 0"></i></p>
              <p><i v-show="password.length > 1"></i></p>
              <p><i v-show="password.length > 2"></i></p>
              <p><i v-show="password.length > 3"></i></p>
              <p><i v-show="password.length > 4"></i></p>
              <p><i v-show="password.length > 5"></i></p>
            </div>
          </div>
        </div>
        <div class="btn" @click="comfirmPay">确认支付</div>
      </div>
    </div>
    <!-- 支付成功提示 -->
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      cemter
      width="30%">
      <span style="font-size:20px;font-weight: bold;color: #333333;">支付成功！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="goShopping">前往购物车</el-button>
        <el-button type="primary" @click="orderDetail">订单详情</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  BonusAccount,
  WalletPay, // 余额支付
} from '../api/api'
export default {
  name: 'ax-payment',
  data(){
    return{
      dialogVisible: false,
      radio: null,
      money: this.$route.query.money || 0,
      orderNo: this.$route.query.orderNo || 0,
      balance: 0,
      password: ''
    }
  },
  created(){
    this.getBonusAccount()
  },
  methods:{
    handleRadioFun(val){
      if(val == 3 && this.money > this.balance){
        this.radio = null
        return this.$message.error('账户余额不足!')
      }
    },
    comfirmPay(){
      if(this.radio == 1){

      } else if(this.radio == 2){

      } else if(this.radio == 3){
        this.balancePay()
      }
    },
    getBonusAccount(){
      BonusAccount({}).then(res => {
        if(res.data.success){
          this.balance = res.data.response.Balance
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    balancePay(){
      if (this.password.length === 6) {
        let params = {
          orderNo: this.$route.query.orderNo,
          payPassword: this.password
        }
        WalletPay(params).then(res =>{
          if(res.data.success){
            this.radio = null
            this.dialogVisible = true
          } else{
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    goShopping(){
      this.$router.push({path: '/shoppingCart'})
    },
    orderDetail(){
      alert('去订单列表')
    }
  }
}
</script>
<style lang="scss" scoped>
.payment{
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 20px;
  text-align: left;
  .head-title{
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    .title{
      margin-left: 20px;
      font-size: 20px;
      font-weight: bold;
      color: #333333;
    }
  }
  .order-info{
    margin-top: 20px;
    .lable{
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 10px;
    }
    // .info{
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    // }
    .btn{
      text-align: center;
      width: 120px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      background: #f40000;
      border-radius: 4px;
      margin: 20px 0;
    }
  }
  .password-box{
    margin-top: 20px;
    .inputTable{
      border:1px solid #D6D6D6;
      display:inline-block;
      font-size:0;
      position: relative;
      overflow:hidden;
      input{
        display:block;
        width:calc(100% + 100px);
        height:100%;
        position: absolute;
        left:-100px;
        top:0;
        z-index:20;
        opacity:0;
        font-size:16px;
      }
      .passIcon{
        display: flex;
        justify-content: center;
        align-items: center;
      }
      p{
        display: flex;
        justify-content: center;
        align-items: center;
        width:36px;
        height:36px;
        border-right:1px solid #D6D6D6;
        &:last-child{border-right: none; width: 37px;}
        i{
          width:8px;
          height:8px;
          display:block;
          background:#333;
          border-radius:100px;
        }
      }
      .vcodeBox{
        p>span{
          width:100%;
          height:100%;
          background:#fff;
          border-radius:0;
          font-weight:700;
        }
      }
    }
  }
}
</style>